<template>
  <Row>
    <h1>Analysis Dashboard</h1>
    <br />
    <MonthlyFiguresDisastersChart />
  </Row>
</template>

<script>
import MonthlyFiguresDisastersChart from "./components/MonthlyFiguresDisastersChart.vue";

export default {
  components: {
    MonthlyFiguresDisastersChart,
  },
};
</script>

<style lang="scss" scoped>
</style>
